import revertIcon from "../../../../assets/images/revert.svg";
import redo from "../../../../assets/images/redo.svg";
import calenderOne from "../../../../assets/images/calender1.svg";
import uploadicon from "../../../../assets/images/uploadicon.png";
import { useState } from "react";
import { ScheduleUpload_URL } from "../../../../service/API_URL";
import { postFormData } from "../../../../api/apiMethod";
import { toast } from "react-toastify";
import { CsvErrorPopUp } from "../../CsvErrorPopUp";

export const HeaderSection = ({ 
    locationState,
    updateLoopData, 
    loaderStatus, 
    undoGridList,
    redoGridList,
    canUndo,
    canRedo,
    setWeeklyView,
    fetchLoopData
}) => {
    const [showPopup, setShowPopup] = useState(false);
    const [csvErrorData, setCsvErrorData] = useState([]);

    const listUpdate = (channelAssembly) => {
        if (channelAssembly === "RUNN_MEDIA") {
            document.getElementById("fileid").click();
        }
    }
    const uploadFile = async (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const formData = new FormData();
            formData.append("file", selectedFile);
            try {
                let URL = "";
                if (locationState?.state?.channelAssembly === "RUNN_MEDIA") {
                    URL = `${ScheduleUpload_URL}/${locationState?.state?.channelId}/schedule/internal/csv`;
                } else {
                    URL = `${ScheduleUpload_URL}/${locationState?.state?.channelId}/schedule/external/csv`;
                }
                const response = await postFormData(URL, formData);
                
                if (response?.data?.status) {
                    toast.success("File uploaded successfully", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 5000,
                    });
                    fetchLoopData();
                } else {
                    if (response?.data?.data != null) {
                        setShowPopup(true);
                        setCsvErrorData({...response?.data, fileName: selectedFile?.name});
                    }
                    toast.error(response?.data?.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 10000,
                    });
                }
            } catch (error) {
                toast.error(error.response.data.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 10000,
                });
            }
        }
        event.target.value = ""; 
    }
    const closePopup = () => {
        setShowPopup(false);
    };
    return (
        <>
            <div className="left-side">
                <h3 style={{fontSize: '24px', color: '#BFBFBF'}}>{locationState?.state?.channelName}</h3>
            </div>
            <div className="right-side d-flex align-items-center">
                <a className='btn btn-revert mx-2' onClick={undoGridList} disabled={!canUndo} style={{width: '2.25rem', height:'2.25rem', background: "#444649"}}><img src={revertIcon} width={35}/></a>
                <a className='btn btn-revert mx-2' onClick={redoGridList} disabled={!canRedo} style={{width: '2.25rem', height:'2.25rem', background: "#444649"}}><img src={redo} width={35}/></a>
                <a className='btn btn-revert mx-2' onClick={() => listUpdate(locationState?.state?.channelAssembly)} style={{width: '2.25rem', height:'2.25rem', background: "#444649"}}><img src={uploadicon} style={{filter: "invert(0.90)"}} width={35}/></a>
                <a className='btn btn-revert mx-2' onClick={setWeeklyView} style={{width: '2.25rem', height:'2.25rem', background: "#444649"}}><img src={calenderOne} width={35}/></a>
                {
                    locationState?.state?.permission === "edit" &&
                    <button 
                        className='btn btn-primary mx-2 radius-8x' 
                        disabled={loaderStatus} 
                        onClick={updateLoopData}
                        style={{
                            height: '2.5rem',
                            width: 'auto'
                        }}
                    >
                        {
                            loaderStatus &&
                            <div className="loader" style={{width: "20px", height: "20px", marginBottom: "0px"}}>
                            </div>
                        }
                        Update
                    </button>
                }
                <button className='btn btn-danger mx-2 radius-8x' style={{ height: '2.5rem', width:'9.5rem'}}>Auto Schedule</button>
            </div>
            <input
                id="fileid"
                type="file"
                hidden
                onChange={(event) => uploadFile(event)}
            />
            {
                showPopup &&
                <CsvErrorPopUp show={showPopup} csvErrorData={csvErrorData} handleClose={closePopup}/>
            }
        </>
    )
}